/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-08-04.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-08-04.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-04.mdx';

const metadata = {
  slug: "2020-08-04",
  title: "Universal/Isomorphic Websites",
  author: "Christian Battaglia",
  description: "Surveying the landscape of universal/isomorphic web frameworks — React, Vue, Nuxt, Next.js, and the quest to render the same code on server and client.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-04T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["SSR","isomorphic","React","Vue","Nuxt","Next.js","web frameworks","JavaScript"],
};

export const Route = createFileRoute('/blog/posts/2020-08-04')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-04',
    image: '/og/blog/2020-08-04.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
